
/// <amd-module name="Environments/ProviderCreateDetails/VirtualMachineGroups/Stores/VirtualMachineGroupCreateStore" />
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { EnvironmentResourceReference } from "DistributedTask/Client/Contracts/TaskAgent";
import { StoreBase, IStoreState } from "Environments/Flux/Store"
import { VirtualMachineGroupCreateActions } from "Environments/ProviderCreateDetails/VirtualMachineGroups/Actions/VirtualMachineGroupCreateActions";

export interface IResourceStoreState extends IStoreState {
    resource: EnvironmentResourceReference;
}

export class VirtualMachineGroupCreateStore extends StoreBase {

    public static getKey(): string {
        return "virtualmachinegroup-create-store";
    }
    
    public initialize(instanceId: string): void {
        super.initialize(instanceId);
        
        this._actionsHub = ActionsHubManager.GetActionsHub<VirtualMachineGroupCreateActions>(VirtualMachineGroupCreateActions, instanceId);
        this._actionsHub.addVirtualMachinesResource.addListener(this._handleAddVirtualMachinesResource);
    }
    
    protected disposeInternal(): void {
        this._actionsHub.addVirtualMachinesResource.removeListener(this._handleAddVirtualMachinesResource);
    }

    public getState(): IResourceStoreState {
        return this._state;
    }

    private _handleAddVirtualMachinesResource = (resource: EnvironmentResourceReference) => {
        this._state.resource = resource;
        this.emitChanged();
    }

    private _actionsHub: VirtualMachineGroupCreateActions;
    private _state: IResourceStoreState = {} as IResourceStoreState;
}
